import { AxiosProgressEvent, AxiosResponse } from "axios";

import { EAccount } from "types/index";
import { API_QUERY_TYPE } from "./constants";

type Sort = {
  key: string;
  type: string;
};

export type TPhoneNumber = {
  isdCode: string;
  number: string;
};

export type TAddress = {
  id?: string;
  name: string;
  country: string;
  postalCode: string;
  addressLine1: string;
  addressLine2: string;
  prefecture?: string;
  city: string;
  phoneNumber: TPhoneNumber;
  isDefault: boolean;
  isResidence: boolean;
};

export type PaginationReq = {
  page: number;
  pageSize: number;
  keyword?: string;
  sort?: Sort;
  idBusinessUnit?: string;
};

export enum EMethod {
  "POST" = "POST",
  "PUT" = "PUT",
  "DEL" = "DELETE",
  "GET" = "GET",
  "PATCH" = "PATCH",
}

export type TCallbackUpload = (
  payload: any,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => Promise<AxiosResponse<any, any>>;

export type TOptionData = {
  id: string;
  name: string;
};

export type TImageList = {
  id: string;
  profilePicture: string;
  label: string;
  type?: EAccount;
  isBlacklisted?: boolean;
};

export type TRawPagination<T> = {
  page: number;
  pageSize: number;
  total: number;
  data: T[];
};

export type TAPIQueryType =
  (typeof API_QUERY_TYPE)[keyof typeof API_QUERY_TYPE];
